const t = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i, e = (s) => !!s && typeof s == "string" && t.test(s);
export {
  t as emailRegex,
  e as isEmailValid
};
//# sourceMappingURL=validations.es.js.map
